
export default {
  async getRequirementSpecifications ({ state, commit }) {
    const data = await this.$api.getRequirementSpecifications()
    commit('SET_REQUIREMENT_SPECIFICATIONS', data)
  }

}
